import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="border-y border-orange-500/40 bg-slate-950 text-center text-white" aria-label="Limited time offer" data-id="element-205" data-mp="2sk46nkhn1yb1">
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-206" data-mp="36bsg1g0i68ob">
        <p className="inline-flex items-center gap-2 text-sm font-semibold text-orange-400" data-id="element-207" data-mp="31i6ae7srb520">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-208" data-mp="3g72ho2mzoe1k" /> Launch pricing ends in:
        </p>
        <Countdown className="mt-5" data-id="element-209" data-mp="3b7ze6mmnqfvp" />
        <p className="mt-7 font-medium text-slate-300" data-id="element-210" data-mp="3bb50ju3wj3nq">After that the price increases and never drops again.</p>
      </div>
    </section>;
}